const REQUIRED_PROJECT_FIELDS = [
  "id",
  "name",
  "category",
  "status",
  "pitch",
  "stack",
  "withoutAiHours",
  "withAiHours",
];

export function createProjectEntity(rawProject) {
  const missing = REQUIRED_PROJECT_FIELDS.filter((field) => rawProject[field] === undefined);
  if (missing.length > 0) {
    throw new Error(`Invalid project entity. Missing fields: ${missing.join(", ")}`);
  }

  const withoutAiHours = Number(rawProject.withoutAiHours);
  const withAiHours = Number(rawProject.withAiHours);

  if (!Number.isFinite(withoutAiHours) || !Number.isFinite(withAiHours) || withoutAiHours <= 0) {
    throw new Error(`Invalid project hours for ${rawProject.id}`);
  }

  return {
    ...rawProject,
    withoutAiHours,
    withAiHours,
    stack: Array.isArray(rawProject.stack) ? rawProject.stack : [],
  };
}
